// extracted by mini-css-extract-plugin
export default {"colorPrimary":"#007afc","colorSecondary":"#f0f7ff","colorInfo":"#10a479","colorError":"#d52b1e","font":"\"Roobert\",Arial,Helvetica,sans-serif"};